import React from "react";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";

type Props = {workflowTests: AggregatedWorkflowTest[]};

export default function Summary({workflowTests}: Props) {
  const testLength = workflowTests ? workflowTests.length : 0;
  const passRate = workflowTests
    ? workflowTests?.reduce(
        (state, test) => state + (test.average_all_pass_score ? 1 : 0),
        0,
      ) / workflowTests.length
    : 0;
  const avgScore = workflowTests
    ? workflowTests?.reduce(
        (state, test) => state + (test.average_score ? 1 : 0),
        0,
      ) / workflowTests.length
    : 0;
  return (
    <div>
      <table>
        <tbody>
          <tr>
            <th>Total Tests: </th>
            <td>{testLength}</td>
          </tr>
          <tr>
            <th>Pass Rate:</th>
            <td>{(Math.round(passRate * 10000) / 100).toFixed(2)}%</td>
          </tr>
          <tr>
            <th>Avg Score:</th>
            <td>{(Math.round(avgScore * 10000) / 100).toFixed(2)}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
